import { GET_RESERVATIONS,GET_RESERVATION_SUGGESTED_SEATS, GET_RESERVATIONBYID } from '../types';

const initialState = {
  reservations: [],
  reservation: []
};

const getReservations = (state, payload) => ({
  ...state,
  reservations: payload
});

const getReservationById = (state, payload) =>({
  ...state,
  reservation: payload
})

const getReservationSuggestedSeats = (state, payload) => ({
  ...state,
  suggestedSeats: payload
});

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_RESERVATIONS:
      return getReservations(state, payload);
    case GET_RESERVATION_SUGGESTED_SEATS:
      return getReservationSuggestedSeats(state, payload);
    case GET_RESERVATIONBYID:
      return getReservationById(state, payload)
    default:
      return state;
  }
};
